import { routes } from './app/app.routes';
import { enableProdMode, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { registerLicense } from '@syncfusion/ej2-base';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { BaseModule } from './app/base/base.module';
import { DomainModule } from './app/domain/domain.module';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

// Registering Syncfusion license key
registerLicense(environment.syncfusionKey);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
      provideZoneChangeDetection(),
      provideBrowserGlobalErrorListeners(),
      provideRouter(routes),
      importProvidersFrom(DomainModule, BaseModule)]
})
  .catch(err => console.error(err));
